//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { getWorkShiftIconName } from '../../components/helpers.js'
import { Store } from '../../components/QSelectUtils.js'
import TableServer from '../../components/Table/Table.vue'

export default {
  name: 'RequestAutoAssignBrigades',
  components: {
    TableServer
  },
  props: {
    requestId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      lastAutoAssignTime: null,
      store: new Store({
        itemsFn: this.load,
        cached: true, // server
        searchFiltrationBySource: false,
        searchable: true,
        fullReadable: true
      }),
      columns: [
        {
          name: 'mainData',
          label: 'Бригада',
          align: 'left',
          field: 'guiName',
          defaultWidth: 250,
          sortable: true,
          format: (val, row) => {
            return row.mainData
          }
        },
        {
          name: 'messages',
          label: 'Сообщения',
          defaultWidth: 350,
          align: 'left',
          field: 'messages',
          sortable: false
        }
      ]
    }
  },
  computed: {
    lastAutoAssignTimeText: function () {
      return this.lastAutoAssignTime ? date.formatDate(this.lastAutoAssignTime, 'HH:mm:ss') : 'нет данных'
    }
  },
  methods: {
    load: function () {
      return axiosGet({
        url: '/service/delta/request/getAutoAssignBrigades?id=' + this.requestId,
        onSuccess: response => {
          const autoAssignData = response.data
          this.lastAutoAssignTime = autoAssignData.time
          return autoAssignData.result
        },
        onFailure: 'Ошибка получения бригад для автоназначения',
        throws: true
      })
        .then(brigades => {
          const currentTime = new Date().getTime()
          brigades.forEach(brigade => {
            brigade.mainData = {
              guiName: brigade.guiName,
              workAreas: brigade.workAreas.join(','),
              workShiftIcon: getWorkShiftIconName(brigade.workShift),
              workShiftName: brigade.workShift ? brigade.workShift.name : null,
              date: brigade.startWorkTime ? date.formatDate(brigade.startWorkTime, 'DD.MM') : '',
              dateColor: brigade.startWorkTime && brigade.startWorkTime < currentTime ? 'blue' : 'black',
              excluded: brigade.excluded,
              excludedActually: brigade.excludedActually
            }
          })
          return brigades
        })
    },
    onRemoveExcludedBrigade: function (brigade) {
      axiosPost({
        url: '/service/delta/request/removeExcludedBrigade?id=' + this.requestId + '&brigadeId=' + brigade.id,
        onSuccess: response => {
          this.$q.notify({
            type: 'positive',
            message: 'Бригада удалена из списка исключений',
            progress: true,
            timeout: 3000
          })

          this.store.reset()
          this.$refs.table.onUpdate()
        },
        onFailure: 'Ошибка удаления бригады из списка исключений'
      })
    },
    getWorkShiftIconName: function (workShift) {
      if (workShift) {
        const key = workShift.key ? workShift.key : workShift
        return getWorkShiftIconName(key)
      } else {
        return ''
      }
    },
    getMessageStyle: function (message) {
      // black, red, orange, yellow, null
      const bgColor = message.color || 'transparent'
      const color = bgColor === 'red' || bgColor === 'black' ? 'white' : 'black'
      return `font-weight: 500;
          background-color: ${bgColor};
          color: ${color};
          border-bottom: 1px solid white;
          padding-left: 2px;
          white-space: pre-line;`
    }
  }
}
